import React from 'react'
import { Link } from 'react-router-dom'
import * as ROUTES from '../../constants/routes'
import { Button, Grid, Card, List, ListItem, ListItemText, ListItemIcon, Chip } from '@material-ui/core'
import AppsIcon from '@material-ui/icons/Apps'
import DashboardIcon from '@material-ui/icons/Dashboard'
import FeedbackIcon from '@material-ui/icons/Feedback'
import DomainIcon from '@material-ui/icons/Domain'
import DnsIcon from '@material-ui/icons/Dns'
import AccountBoxIcon from '@material-ui/icons/AccountBox'

class Pricing extends React.Component {

    componentWillMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div style={{ paddingBottom: '60px' }}>
                <div style={{ padding: '20px', fontSize: '2em' }}>Pricing</div>
                <br />
                <Grid container spacing={24} justify='center'>
                    <Grid item xs={11} md={3}>
                        <Card style={{ minHeight: '400px', padding: '20px' }}>
                            {/* <Grid container spacing={24} direction='column'> */}
                                <span style={{ fontSize: '1.3em' }}>Basic Web</span>
                                <hr />
                                <List>
                                    <ListItem>
                                        <ListItemIcon><AppsIcon /></ListItemIcon>
                                        <ListItemText primary='1-5 page live app' secondary='fast routing between pages' />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><DashboardIcon /></ListItemIcon>
                                        <ListItemText primary='custom styles, images and text' secondary='choose and customize components' />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><FeedbackIcon /></ListItemIcon>
                                        <ListItemText primary='1 web form' secondary='validated formatted and emailed' />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon><DomainIcon /></ListItemIcon>
                                        <ListItemText primary='domain name support' secondary='register new or BYOD' />
                                    </ListItem>
                                </List>
                                <hr />
                                <span>1-2 weeks</span>
                                <hr />
                                <span>1500 USD</span>
                            {/* </Grid> */}
                        </Card>
                    </Grid>
                    <Grid item xs={11} md={3}>
                        <Card style={{ minHeight: '400px', padding: '20px', border: '2px solid green' }}>
                            <span style={{ fontSize: '1.3em', paddingRight: '10px' }}>Data Driven</span>
                            <Chip label='Most Popular' style={{ backgroundColor: 'rgb(190, 230, 255)', color: 'green' , fontWeight: 'bold', fontSize: '0.5em' }} />
                            <hr />
                            <List>
                                <ListItem>
                                    <ListItemIcon><AppsIcon /></ListItemIcon>
                                    <ListItemText primary='1-10 page live app' secondary='fast routing between pages' />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><DashboardIcon /></ListItemIcon>
                                    <ListItemText primary='custom styles, images and text' secondary='choose and customize components' />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><FeedbackIcon /></ListItemIcon>
                                    <ListItemText primary='3 web forms' secondary='validated formatted and emailed' />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><DomainIcon /></ListItemIcon>
                                    <ListItemText primary='domain name included' secondary='register new or BYOD' />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><DnsIcon /></ListItemIcon>
                                    <ListItemText primary='live-synced database back-end' secondary='realtime flexible noSQL database' />
                                </ListItem>
                            </List>
                            <hr />
                            <span>2-3 weeks</span>
                            <hr />
                            <span>2600 USD</span>
                        </Card>
                    </Grid>
                    <Grid item xs={11} md={3}>
                        <Card style={{ minHeight: '400px', padding: '20px' }}>
                            <span style={{ fontSize: '1.3em' }}>User Focused</span>
                            <hr />
                            <List>
                                <ListItem>
                                    <ListItemIcon><AppsIcon /></ListItemIcon>
                                    <ListItemText primary='1-20 page live app' secondary='fast routing between pages' />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><DashboardIcon /></ListItemIcon>
                                    <ListItemText primary='custom styles, images and text' secondary='choose and customize components' />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><FeedbackIcon /></ListItemIcon>
                                    <ListItemText primary='5 web forms' secondary='validated formatted and emailed' />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><DomainIcon /></ListItemIcon>
                                    <ListItemText primary='domain name included' secondary='register new or BYOD' />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><DnsIcon /></ListItemIcon>
                                    <ListItemText primary='live-synced database back-end' secondary='realtime flexible noSQL database' />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><AccountBoxIcon /></ListItemIcon>
                                    <ListItemText primary='user management' secondary='authentication and user data' />
                                </ListItem>
                            </List>
                            <hr />
                            <span>1-2 months</span>
                            <hr />
                            <span>4200 USD</span>
                        </Card>
                    </Grid>
                </Grid>
                <br /><br />
                <Grid container spacing={16} justify='center'>
                    <Grid item xs={2}>
                        <Button variant='contained' color='primary' component={Link} to={ROUTES.HOME}>
                            back
                        </Button>
                    </Grid>
                    <Grid item xs={2}>
                        <Button variant='contained' color='primary' component={Link} to={ROUTES.CONTACTUS}>
                            contact us
                        </Button>
                    </Grid>
                </Grid>
            </div>
        )
    }
    
}

export default Pricing
